import { render, staticRenderFns } from "./FreeReport.vue?vue&type=template&id=b0f3e480&scoped=true&"
import script from "./FreeReport.vue?vue&type=script&lang=js&"
export * from "./FreeReport.vue?vue&type=script&lang=js&"
import style0 from "./FreeReport.vue?vue&type=style&index=0&id=b0f3e480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f3e480",
  null
  
)

component.options.__file = "FreeReport.vue"
export default component.exports